import React, { useState, useEffect } from "react"
import { useLocation, useHistory } from "react-router-dom"

import { HiOutlineArrowNarrowLeft } from "react-icons/hi"
import { BiDish } from "react-icons/bi"
import { AiOutlineClockCircle } from "react-icons/ai"
import Steps from "../../components/randomRecipe/Steps"
import Ingredients from "../../components/randomRecipe/Ingredients"
import Equipment from "../../components/randomRecipe/Equipment"

function RecipePage({ allRecipes, displayPage }) {
    const location = useLocation()
    const history = useHistory()
    const recipeId = Number( location.pathname.substr(8) )
    const [ recipe, setRecipe ] = useState({})
    const [ steps, setSteps ] = useState([])
    const [ ingredients, setIngredients ] = useState([])
    const [ equipment, setEquipment ] = useState([])
    const { title, 
        image, 
        veryHealthy, 
        vegetarian, 
        vegan, 
        glutenFree, 
        dairyFree, 
        readyInMinutes, 
        servings,
        analyzedInstructions,
        summary
    } = recipe

    useEffect(() => {
        const getRecipe = () => {
            allRecipes.forEach( item => {
                if ( item.id === recipeId ) {
                    setRecipe( item )
                    setIngredients( item?.extendedIngredients )
                }
            })
        }
        if ( recipe?.analyzedInstructions !== undefined ) {
            setSteps( recipe?.analyzedInstructions[0]?.steps )
            analyzedInstructions[0]?.steps?.map( step => {
                return setEquipment( step.equipment )
            })
        }
        getRecipe()
    }, [ recipeId, 
        allRecipes, 
        recipe.analyzedInstructions,
        analyzedInstructions,
        ingredients,
        steps ])

    const changeRoute = () => {
        displayPage()
        history.push( "/" )
    }

    return (
        <section>
            <button className="goBackBtn" onClick={changeRoute}><HiOutlineArrowNarrowLeft size="20px" /></button>
            <article className="recipePage">
                <header>
                    <section>
                        <h2>{title}</h2>
                        <div className="diets">
                            <span className={veryHealthy ? "details active" : "details"}>Healthy</span>
                            <span className={vegetarian ? "details active" : "details"}>Vegetarian</span>
                            <span className={vegan ? "details active" : "details"}>Vegan</span>
                            <span className={glutenFree ? "details active" : "details"}>Gluten Free</span>
                            <span className={dairyFree ? "details active" : "details"}>Dairy Free</span>
                        </div>
                        <div>
                            <BiDish size="22px" /> 
                            <p>{servings} servings</p>
                        </div>
                        <div>
                            <AiOutlineClockCircle size="20px" /> 
                            <p>{readyInMinutes} minutes</p>
                        </div>
                    </section>
                    <img src={image} alt="Recipe Info" />
                </header>

                <div className="summary">
                    <p>{summary?.replace(/<\/?[^>]+>/gi, "")}</p>
                </div>

                <Ingredients ingredients={ingredients} />
                <Equipment equipment={equipment} />
                <Steps steps={steps} />
            </article>
        </section>
    )
}

export default RecipePage
